<template>
	<div class="v5-swiper">
		<!-- swiper lists -->
		<div class="v5-swiper-main" :style="{height: getHeight}">
			<div class="v5-swiper-item"
				v-for="(item, index) in list"
				:key="index"
				@click="clickItem(item)"
				:data-index="current">
				<div class="v5-swiper-img" :style="{backgroundImage: getBgUrl(item.img)}"></div>
				<p class="v5-swiper-desc" v-if="showDescMask">{{item.title}}</p>
			</div>
		</div>
		<!-- swiper dots -->
		<div :class="[dotsClass, 'v5-indicator', 'v5-indicator-' + dotsPosition]" v-if="showDots">
			<template v-for="key in length">
				<span :key="key"
					class="v5-icon-dot"
					:class="{'v5-dot-active': key - 1 === current}"
					@click="changeDot(key - 1)">
				</span>
			</template>
		</div>
		<!-- swiper btns -->
		<template v-if="showBtns">
			<icon type="arrow-left" class="v5-swiper-btn arrow-left" @click.native="goPrev"></icon>
			<icon type="arrow-right" class="v5-swiper-btn arrow-right" @click.native="goNext"></icon>
		</template>
	</div>
</template>

<script>
import Swiper from './swiper.js';
import Icon from './../icon';

export default {
	props: {
		value: {
			type: Number,
			default: 0
		},
		list: {
			type: Array,
			default() {
				return [];
			}
		},
		direction: {
			type: String,
			default: 'horizontal'
		},
		showDots: {
			type: Boolean,
			default: true
		},
		showBtns: {
			type: Boolean,
			default: false
		},
		showDescMask: {
			type: Boolean,
			default: true
		},
		dotsPosition: {
			type: String,
			default: 'right'
		},
		dotsClass: String,
		auto: {
			type: Boolean,
			default: false
		},
		loop: {
			type: Boolean,
			default: false
		},
		interval: {
			type: Number,
			default: 3000
		},
		threshold: {
			type: Number,
			default: 50
		},
		duration: {
			type: Number,
			default: 300
		},
		height: {
			type: String,
			default: 'auto'
		},
		aspectRatio: Number,
		minMovingDistance: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			current: this.value || 0,
			length: this.list.length
		};
	},
	mounted() {
		this.$nextTick(() => {
			if (!(this.list && this.list.length === 0)) {
				this.render();
			}
		});
	},
	watch: {
		value(val) {
			this.current = val;
		},
		current(val) {
			this.$nextTick(() => {
				this.swiper && this.swiper.go(val);
			});
			this.$emit('input', val);
		},
		list(val) {
			this.rerender();
		}
	},
	methods: {
		// 上一页按钮切换
		goPrev() {
			this.current--;
		},
		// 下一页按钮切换
		goNext() {
			this.current++;
		},
		// 指示标切换
		changeDot(index) {
			this.current = index;
			this.$emit('on-change-dot', index);
		},
		// 当前banner点击
		clickItem(item) {
			this.$emit('on-click-item', item);
		},
		// 背景图片
		getBgUrl(url) {
			return `url(${url})`;
		},
		render(index = 0) {
			this.swiper && this.swiper.destroy();
			this.swiper = new Swiper({
				container: this.$el,
				direction: this.direction,
				auto: this.auto,
				loop: this.loop,
				interval: this.interval,
				threshold: this.threshold,
				duration: this.duration,
				height: this.height,
				minMovingDistance: this.minMovingDistance
			}).on('swiped', (prev, index) => {
				this.current = index % this.length;
			});
			if (index > 0) {
				this.swiper.go(index);
			}
		},
		rerender() {
			if (!this.$el) {
				return;
			}
			this.$nextTick(() => {
				this.current = this.value || 0;
				this.length = this.list.length || this.$children.length;
				this.destroy();
				this.render(this.value);
			});
		},
		destroy() {
			this.swiper && this.swiper.destroy();
		}
	},
	computed: {
		getHeight() {
			// when list.length > 0, it's better to set height or ratio
			const hasHeight = parseInt(this.height, 10);
			if (hasHeight) return this.height;
			if (!hasHeight) {
				if (this.aspectRatio) {
					return this.$el.offsetWidth * this.aspectRatio + 'px';
				}
				return '180px';
			}
		}
	},
	components: {
		Icon
	},
	beforeDestroy() {
		this.destroy();
	}
};

</script>

<style lang="scss">
@import './style.scss';
</style>
